import { render, staticRenderFns } from "./IconDetails.vue?vue&type=template&id=3a400249&"
var script = {}
import style0 from "./IconDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a400249')) {
      api.createRecord('3a400249', component.options)
    } else {
      api.reload('3a400249', component.options)
    }
    module.hot.accept("./IconDetails.vue?vue&type=template&id=3a400249&", function () {
      api.rerender('3a400249', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/IconDetails.vue"
export default component.exports